var map = {
	"./footer-knotwilg.svg": 611,
	"./icon-checks.svg": 551,
	"./icon-strl-white.svg": 863,
	"./icon-stuurlui-blue.svg": 528,
	"./icon-stuurlui-global.svg": 97,
	"./logo.svg": 717,
	"./strl-16px.png": 198,
	"./strl-36px.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;